import { useState } from "react";

interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  createdAt: string;
  lastUsed: string | null;
}

export default function ApiKeysPage() {
  const [keys] = useState<ApiKey[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [keyName, setKeyName] = useState("");

  const handleCreate = () => {
    // Wire to api-auth API key creation endpoint
    setShowCreate(false);
    setKeyName("");
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-foreground">API Keys</h2>
          <p className="text-sm text-muted-foreground">Manage API keys for programmatic access</p>
        </div>
        <button
          onClick={() => setShowCreate(true)}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Create key
        </button>
      </div>

      {showCreate && (
        <div className="rounded-md border border-border p-4">
          <label htmlFor="key-name" className="block text-sm font-medium text-foreground">Key name</label>
          <div className="mt-1 flex gap-3">
            <input
              id="key-name"
              type="text"
              value={keyName}
              onChange={(e) => setKeyName(e.target.value)}
              placeholder="e.g., Production API"
              className="flex-1 rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
            />
            <button
              onClick={handleCreate}
              disabled={!keyName.trim()}
              className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
            >
              Create
            </button>
            <button
              onClick={() => setShowCreate(false)}
              className="rounded-md border border-border px-3 py-2 text-sm text-foreground hover:bg-accent"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {keys.length === 0 ? (
        <div className="rounded-md border border-border p-8 text-center">
          <p className="text-muted-foreground">No API keys yet. Create one to get started.</p>
        </div>
      ) : (
        <div className="rounded-md border border-border divide-y divide-border">
          {keys.map((key) => (
            <div key={key.id} className="flex items-center justify-between p-4">
              <div>
                <p className="font-medium text-foreground">{key.name}</p>
                <p className="text-sm text-muted-foreground font-mono">{key.prefix}...</p>
              </div>
              <button className="rounded-md border border-destructive px-3 py-1.5 text-sm text-destructive hover:bg-destructive/10">
                Revoke
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
